export const routeName = 'cookies';
/** The same word in all five, matching the archived site. */
export const slugs: Record<string, string> = {
	es: 'cookies',
	en: 'cookies',
	ca: 'cookies',
	fr: 'cookies',
	it: 'cookies',
};
export const sitemap = { changefreq: 'yearly', priority: '0.3', lastmod: '2026-09-02' };
